import React from "react";
import { Slider, SliderProps } from "@mui/material";

const DSSlider: React.FC<SliderProps> = (props) => {
  return <Slider {...props} />;
};

export default DSSlider;
